
export const SET_NOTIFICATION_COUNTER = 'SET_NOTIFICATION_COUNTER';

export const setNotificationCounter = (pageNumber: boolean) => ({
  type: SET_NOTIFICATION_COUNTER,
  payload: pageNumber,
});
